import axios from 'redaxios';

import tabs from '../features/tabs';
import {RadioSwatch} from '../features/swatch';
import {ProductGridItem} from '../features/product-grid-item';
import {ProductGridItemVariant} from '../features/product-grid-item-variant';
import {ProductGridItemImage} from '../features/product-grid-item-image';
import {register} from '../vendor/theme-scripts/theme-sections';
import {recentProducts} from '../features/recent-products';

const selectors = {
  dataRelatedSectionElem: '[data-related-section]',
  dataRelatedProduct: '[data-grid-item]',
  carousel: '[data-carousel]',
  dataLimit: 'data-limit',
  dataMinimum: 'data-minimum',
  dataLargeLayout: 'data-layout-desktop',
  dataMediumLayout: 'data-layout-tablet',
  dataSmallLayout: 'data-layout-mobile',
  recentlyViewed: '[data-recent-wrapper]',
  recentlyViewedWrapper: '[data-recently-viewed-wrapper]',
  productId: 'data-product-id',
};

class Related {
  constructor(section) {
    this.section = section;
    this.container = section.container;

    this.init();

    this.container.addEventListener('theme:recent-products:added', () => {
      this.recent();
    });
  }

  init() {
    const relatedSection = this.container.querySelector(selectors.dataRelatedSectionElem);

    if (!relatedSection) {
      return;
    }

    const productId = relatedSection.getAttribute(selectors.productId);
    const limit = relatedSection.getAttribute(selectors.dataLimit);
    const layoutLarge = relatedSection.getAttribute(selectors.dataLargeLayout);
    const layoutMedium = relatedSection.getAttribute(selectors.dataMediumLayout);
    const layoutSmall = relatedSection.getAttribute(selectors.dataSmallLayout);
    const route = window.theme.routes.product_recommendations_url || '/recommendations/products/';
    const requestUrl = `${route}?section_id=related&limit=${limit}&product_id=${productId}`;

    axios
      .get(requestUrl)
      .then((response) => {
        const fresh = document.createElement('div');
        fresh.innerHTML = response.data;

        const inner = fresh.querySelector(selectors.dataRelatedSectionElem);

        if (inner.querySelector(selectors.dataRelatedProduct)) {
          const innerHtml = inner.innerHTML;
          relatedSection.innerHTML = innerHtml;
          relatedSection.querySelector(selectors.carousel).style.setProperty('--grid-large-items', layoutLarge);
          relatedSection.querySelector(selectors.carousel).style.setProperty('--grid-medium-items', layoutMedium);
          relatedSection.querySelector(selectors.carousel).style.setProperty('--grid-small-items', layoutSmall);
          relatedSection.dispatchEvent(new CustomEvent('theme:related-products:added', {bubbles: true}));
        } else {
          relatedSection.dispatchEvent(
            new CustomEvent('theme:tabs:hide', {
              bubbles: true,
            })
          );
        }
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  recent() {
    const recentlyViewedHolder = this.container.querySelector(selectors.recentlyViewed);
    const recentlyViewedWrapper = this.container.querySelector(selectors.recentlyViewedWrapper);
    const recentProducts = this.container.querySelectorAll(selectors.dataRelatedProduct);

    const minimumNumberProducts = recentlyViewedHolder.hasAttribute(selectors.dataMinimum) ? parseInt(recentlyViewedHolder.getAttribute(selectors.dataMinimum)) : 4;
    const checkRecentInRelated = !recentlyViewedWrapper && recentProducts.length > 0;
    const checkRecentOutsideRelated = recentlyViewedWrapper && recentProducts.length >= minimumNumberProducts;

    if (checkRecentInRelated || checkRecentOutsideRelated) {
      recentlyViewedHolder.dispatchEvent(
        new CustomEvent('theme:tabs:check', {
          bubbles: true,
        })
      );
    }
  }
}

const relatedSection = {
  onLoad() {
    this.section = new Related(this);
  },
};

register('related', [relatedSection, tabs, recentProducts]);

if (!customElements.get('radio-swatch')) {
  customElements.define('radio-swatch', RadioSwatch);
}

if (!customElements.get('product-grid-item')) {
  customElements.define('product-grid-item', ProductGridItem);
}

if (!customElements.get('product-grid-item-variant')) {
  customElements.define('product-grid-item-variant', ProductGridItemVariant);
}

if (!customElements.get('product-grid-item-image')) {
  customElements.define('product-grid-item-image', ProductGridItemImage);
}
